import React from 'react';
import {ProjectHealthTableSectionWrapper, BottomSpacer} from './project_health_styles/ProjectHealthTableSection.styled';
import {CustomScrollDiv} from 'web-components';
import {ProjectHealthTable} from './project_health_table/ProjectHealthTable';

export const ProjectHealthTableSection = ({data, projectHalted}) => {
	return (
		<ProjectHealthTableSectionWrapper>
			<CustomScrollDiv className="custom-scrollbar-div">
				<ProjectHealthTable data={data} projectHalted={projectHalted} />
				<BottomSpacer />
			</CustomScrollDiv>
		</ProjectHealthTableSectionWrapper>
	);
};
